import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
} from "@mui/material";

// Páginas
import Dashboard from "./pages/Dashboard";
import logo from "./img/logofot.png";

// Componentes
import BuscarRues from "./components/BuscarRues";
import ValorAfiliado from "./components/ValorAfiliado";
import CrearAfiliado from "./components/CrearAfiliado";

/* 🔥 HEADER COMPONENT */
function Header() {
  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      sx={{
        background: "linear-gradient(90deg, #0f172a, #1e293b)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* LOGO + NOMBRE */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            src={logo} // 🔥 coloca aquí tu logo en /public
            sx={{
              width: 42,
              height: 42,
              boxShadow: "0 0 10px rgba(255,255,255,0.3)",
              backgroundColor: "white",
            }}
          />

          <Typography variant="h6" fontWeight="bold">
            Repositorio de empresas afiliación
          </Typography>
        </Box>

        {/* MENÚ SIMPLE */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button color="inherit" onClick={() => navigate("/")}>
            Inicio
          </Button>
          <Button color="inherit" onClick={() => navigate("/buscar")}>
            Consultar
          </Button>
          <Button color="inherit" onClick={() => navigate("/crear")}>
            Crear
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

/* 🔥 APP PRINCIPAL */
function AppLayout() {
  return (
    <>
      <Header />

      <Container sx={{ mt: 4 }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/buscar" element={<BuscarRues />} />
          <Route path="/valor" element={<ValorAfiliado />} />
          <Route path="/crear" element={<CrearAfiliado />} />
        </Routes>
      </Container>
    </>
  );
}

/* WRAPPER CON ROUTER */
function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
